<div id="status-holder">
  <div id="status-name">{{holderService.holder.full_name}}</div>
  @if (holderService.holder.active_certificate.status.status === 'ACTIVE') {
    <div class="status" style="color: green;">{{strings.artesStrings['ISSUED']}}</div>
  }
  @if (holderService.holder.active_certificate.status.status === 'INACTIVE') {
    <div class="status" style="color: red;">{{strings.artesStrings['NOT_ISSUED']}}</div>
  }
  @if (holderService.holder.active_certificate.status.status === 'SUSPENDED') {
    <div class="status" style="color: orange;">{{strings.artesStrings['SUSPENDED']}}</div>
  }
  @if (holderService.holder.active_certificate.status.status === 'WITHDRAWN') {
    <div class="status" style="color: orange;">{{strings.artesStrings['WITHDRAWN']}}</div>
  }
  @if (holderService.holder.active_certificate.status.status === 'LOST') {
    <div class="status" style="color: orange;">{{strings.artesStrings['LOST']}}</div>
  }
</div>